export const getSalesPerformanceByCountryData = ({ state }) =>
  state.kpi.salesPerformanceByCountryData;
export const getSalesPerformanceData = ({ state }) => state.kpi.salesPerformanceData;
export const getSalesPerformanceByChannelData = ({ state }) =>
  state.kpi.salesPerformanceByChannelData;
export const getIsKpiLoaderOpen = ({ state }) => state.kpi.isKpiLoaderOpen;
